import { Record } from 'immutable';

const {
    SET_ASSET_TAB_FILTERS,
    RESET_ASSET_TAB_FILTERS,
    
    SET_DIVISION_TAB_FILTERS,
    RESET_DIVISION_TAB_FILTERS,

    SET_TAGS_TAB_FILTERS,
    RESET_TAGS_TAB_FILTERS,

    SET_DRIVER_TAB_FILTERS,
    RESET_DRIVER_TAB_FILTERS,

    SET_USER_TAB_FILTERS,
    RESET_USER_TAB_FILTERS,
} = require('./filtersActions').constants;

const InitialState = Record({
    assetTabFilters: null,
    divisionTabFilters: null,
    tagsTabFilters: null,
    driverTabFilters: null,
    userTabFilters: null,
});

const filtersInitialState = new InitialState();

/**
 * ## galleryReducer function
 * @param {Object} state - initialState
 * @param {Object} action - type and payload
 */
function filtersReducer(state = filtersInitialState, { payload, type }) {
    if (!(state instanceof InitialState)) {
        state = filtersInitialState.mergeDeep(state);
    }

    switch (type) {
        case SET_ASSET_TAB_FILTERS:
            return state
                .set('assetTabFilters', payload);
        case RESET_ASSET_TAB_FILTERS:
            return state
                .set('assetTabFilters', null);
        case SET_DIVISION_TAB_FILTERS:
            return state
                .set('divisionTabFilters', payload);
        case RESET_DIVISION_TAB_FILTERS:
            return state
                .set('divisionTabFilters', null);
        case SET_TAGS_TAB_FILTERS:
            return state
                .set('tagsTabFilters', payload);
        case RESET_TAGS_TAB_FILTERS:
            return state
                .set('tagsTabFilters', null);
        case SET_DRIVER_TAB_FILTERS:
            return state
                .set('driverTabFilters', payload);
        case RESET_DRIVER_TAB_FILTERS:
            return state
                .set('driverTabFilters', null);
        case SET_USER_TAB_FILTERS:
            return state
                .set('userTabFilters', payload);
        case RESET_USER_TAB_FILTERS:
            return state
                .set('userTabFilters', null);
        default:
            return state;
    }
}

export {
    filtersReducer,
    filtersInitialState,
};
